export const TRANSLATION_KEYS = {
  quickStartButton: 'jbp-quick-start-button',
  quickStartButtonTooltip: 'jbp-quick-start-tooltip',
  eltOpener: 'jbp-elt-opener',
  qbrOpener: 'jbp-qbr-opener',
  sobTrends: 'jbp-sob-trends--button-link',
  actions: 'jbp-sob-trends--button-actions',
  consolidatedTooltip: 'jbp-partner-program-type-consolidated-tooltip',

  offerings: {
    turnOnOffering: 'jbp-program-types-turn-on-offering',
    turnOffOffering: 'jbp-program-types-turn-off-offering',
    title: `jbp-program-types-dialog-title`,
    textSwitchOn: `jbp-program-types-dialog-text-switch-on`,
    textSwitchOff: `jbp-program-types-dialog-text-switch-off`,
    ok: `jbp-program-types--dialog-ok`,
    cancel: `jbp-program-types--dialog-cancel`,

    textForDistributorSwitchOn: `jbp-program-types-dialog-text-for-distributor-switch-on`,
    textForDistributorSwitchOff: `jbp-program-types-dialog-text-for-distributor-switch-off`,
  },
}
